import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import CheckIcon from '@rsuite/icons/Check';
import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  SelectPicker,
  IconButton,
  Table,
  Whisper,
  Tooltip,
  Pagination
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { mockUsers } from '@/data/mock';
import EditIcon from '@rsuite/icons/Edit';


const { Column, HeaderCell, Cell } = Table;
const data1 = mockUsers(100);

const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  return (
    <Cell {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>

      ) : (
        <input
          className="rs-input"
          defaultValue={rowData[dataKey]}
          onChange={event => {
            onChange && onChange(rowData.id, dataKey, event.target.value);
          }}
        />
      )}
    </Cell>
  );
};

const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px' }}>
      <Stack spacing={5}>
        <Button
          appearance="subtle"
          active
          onClick={() => {
            onClick(rowData.id);
          }}
        >
          {rowData.status === 'EDIT' ? <Icon as={EditIcon} /> : <Icon as={CheckIcon} />}
        </Button>
        <Link to="/viewCollection">
          <Button
            appearance="subtle" active
          > View</Button></Link>
        <Whisper followCursor speaker={<Tooltip>Discontinue</Tooltip>}>
          <IconButton icon={<TrashIcon />} active />
        </Whisper>
      </Stack>
    </Cell>
  );
};


const EditCollection = () => {



  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const [searchKeyword, setSearchKeyword] = useState('');
  const buyer = ['All Collection'].map(
    item => ({ label: item, value: item })
  );

  const [selectedOption, setSelectedOption] = useState('Option 1');
  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };


  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };

  const data = data1.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const [dataa, setDataa] = React.useState(data1);
  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], dataa);
    nextData.find(item => item.id === id)[key] = value;
    setDataa(nextData);
  };
  const handleEditState = id => {
    const nextData = Object.assign([], dataa);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setDataa(nextData);
  };


  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Edit Collection</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/manageCollection">Collection</Breadcrumb.Item>
                <Breadcrumb.Item active>Edit Collection</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10} >
              <Stack direction='column' alignItems='flex-start' >
                <label>Collection Name</label>
                <SelectPicker data={buyer} size="xs" appearance="default" placeholder="Collection Name" style={{ width: 200 }} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>Status</label>
                <SelectPicker value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'All Catalogues (966)', value: 'Option 1' },
                    { label: 'Draft (183)', value: 'Option 2' },
                    { label: 'Active (755)', value: 'Option 3' },
                    { label: 'Inactive (28)', value: 'Option 4' }
                  ]} size="xs" appearance="default" placeholder="Status" style={{ width: 150 }} />
              </Stack>
              <IconButton size="md" icon={<SearchIcon />} style={{ marginTop: '20px' }} active />
            </Stack>
          </Stack>
          <Stack direction='column' alignItems='flex-end' spacing={44}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' />
        <Panel>
          <Table height={420}
          rowHeight={100}
            data={getData()}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            loading={loading} id="table">

            <Column width={80} align="center" sortable>
              <HeaderCell>S.No.</HeaderCell>
              <Cell dataKey="id" />
            </Column>

            <Column width={300} align="center">
              <HeaderCell>Collection Name</HeaderCell>
              <EditableCell dataKey="name" expandedRowKeys={undefined} onChange={handleChange} rowData={undefined} />
            </Column>

            <Column width={130}>
              <HeaderCell>Total Products</HeaderCell>
              <EditableCell dataKey="age" onChange={handleChange} rowData={undefined} />
            </Column>

            <Column width={130}>
              <HeaderCell>Date Of Creation</HeaderCell>
              <EditableCell dataKey="date" onChange={handleChange} rowData={undefined} />
            </Column>

            <Column width={250}>
              <HeaderCell>Created By</HeaderCell>
              <EditableCell dataKey="name" onChange={handleChange} rowData={undefined} />
            </Column>

            <Column width={150}>
              <HeaderCell>Remark</HeaderCell>
              <EditableCell dataKey="id" expandedRowKeys={undefined} onChange={handleChange} rowData={undefined} />
            </Column>

            <Column width={150}>
              <HeaderCell>Activity</HeaderCell>
              <EditableCell dataKey="id" expandedRowKeys={undefined} onChange={handleChange} rowData={undefined} />
            </Column>


            <Column width={200}>
              <HeaderCell>Action</HeaderCell>
              <ActionCell dataKey="id" rowData={undefined} expandedRowKeys={undefined} onClick={handleEditState} />
            </Column>


          </Table>
          <Stack justifyContent='flex-end'><Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data1.length}
            limitOptions={[10, 30, 50]}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          /></Stack>
        </Panel>
        <Stack className="copyright"    justifyContent="flex-end"  spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
      </Container>
    </>
  );
};

export default EditCollection;